(function () {
  'use strict';

  /* ─── SHEET HTML ─────────────────────────────── */
  function buildSheet() {
    var old = document.getElementById('muga-sheet');
    if (old) { old.remove(); }

    var wrap = document.createElement('div');
    wrap.id = 'muga-sheet';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.innerHTML = [
      '<div id="muga-bd"></div>',
      '<div id="muga-panel">',
        '<button id="muga-cls" aria-label="Close">&times;</button>',
        '<div id="muga-body"></div>',
      '</div>'
    ].join('');

    document.body.appendChild(wrap);
    document.getElementById('muga-bd').onclick = closeSheet;
    document.getElementById('muga-cls').onclick = closeSheet;
    return wrap;
  }

  function closeSheet() {
    var s = document.getElementById('muga-sheet');
    if (!s) { return; }
    s.classList.remove('muga-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (s && s.parentNode) { s.parentNode.removeChild(s); }
    }, 320);
  }

  /* ─── PRICE HELPER ───────────────────────────── */
  function toRupee(paisa) {
    if (!paisa) { return ''; }
    return '\u20B9' + (paisa / 100).toLocaleString('en-IN');
  }

  /* ─── RENDER SHEET CONTENT ───────────────────── */
  function populateSheet(url, product) {
    var sheet   = buildSheet();
    var body    = document.getElementById('muga-body');
    var vlist   = product.variants || [];
    var imgSrc  = (product.images && product.images[0]) ? product.images[0].src : '';
    var fv      = vlist[0] || {};
    var single  = vlist.length === 1 && vlist[0].title === 'Default Title';

    var priceStr = (fv.compare_at_price && fv.compare_at_price > fv.price)
      ? '<s class="muga-cp">' + toRupee(fv.compare_at_price) + '</s> ' + toRupee(fv.price)
      : toRupee(fv.price);

    var sizesBlock = '';
    if (!single) {
      var btns = vlist.map(function (v) {
        var sold = !v.available;
        return '<button type="button" class="muga-sz' + (sold ? ' muga-oos' : '') + '"'
          + ' data-vid="' + v.id + '"'
          + (sold ? ' disabled aria-disabled="true"' : '')
          + '>' + v.title + '</button>';
      }).join('');
      sizesBlock = '<p class="muga-lbl">Select size</p><div class="muga-sizes">' + btns + '</div>';
    }

    body.innerHTML = [
      '<div class="muga-prod">',
        imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy">' : '',
        '<div class="muga-info">',
          '<p class="muga-title">' + product.title + '</p>',
          '<p class="muga-price">' + priceStr + '</p>',
        '</div>',
      '</div>',
      sizesBlock,
      '<button type="button" id="muga-atc" ' + (single ? '' : 'disabled') + '>',
        single ? 'Add to cart' : 'Select a size',
      '</button>',
      '<a href="' + url + '" class="muga-view">View full details \u2192</a>'
    ].join('');

    /* size button clicks */
    var chosen = single ? String(vlist[0].id) : null;

    body.querySelectorAll('.muga-sz').forEach(function (btn) {
      btn.addEventListener('click', function () {
        body.querySelectorAll('.muga-sz').forEach(function (b) {
          b.classList.remove('muga-sel');
        });
        btn.classList.add('muga-sel');
        chosen = btn.getAttribute('data-vid');
        var atc = document.getElementById('muga-atc');
        if (atc) {
          atc.disabled = false;
          atc.textContent = 'Add to cart';
          atc.style.background = '';
        }
      });
    });

    /* add to cart click */
    var atcBtn = document.getElementById('muga-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!chosen) { return; }
        var btn = this;
        btn.disabled = true;
        btn.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(chosen, 10), quantity: 1 }] })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '\u2713 Added!';
          btn.style.background = '#2a7a2a';

          /* update cart bubble */
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var count = cart.item_count;
              document.querySelectorAll(
                '.cart-count-bubble, [data-cart-count], #cart-icon-bubble'
              ).forEach(function (el) {
                el.textContent = count;
                el.removeAttribute('hidden');
              });
              /* open cart drawer if available */
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open(btn);
              }
            });

          setTimeout(closeSheet, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Try again';
        });
      });
    }

    /* animate in */
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sheet.classList.add('muga-open');
      });
    });
  }

  /* ─── FIND PRODUCT URL ───────────────────────── */
  function getProductUrl(startEl) {
    var el = startEl;
    for (var i = 0; i < 10; i++) {
      if (!el) { break; }

      /* data attribute on button or parent */
      var u = el.getAttribute('data-product-url') || el.getAttribute('data-url');
      if (u && u.indexOf('/products/') > -1) { return u; }

      /* anchor inside the card */
      var anchors = el.querySelectorAll ? el.querySelectorAll('a[href*="/products/"]') : [];
      for (var j = 0; j < anchors.length; j++) {
        var href = anchors[j].getAttribute('href');
        if (href) { return href; }
      }

      el = el.parentElement;
    }
    return null;
  }

  /* ─── INTERCEPT CLICKS ───────────────────────── */
  document.addEventListener('click', function (e) {
    var target = e.target;

    /* walk up 3 levels to catch clicks on child elements of button */
    var btn = null;
    var node = target;
    for (var i = 0; i < 3; i++) {
      if (!node) { break; }
      if (node.tagName === 'BUTTON' || node.tagName === 'A') {
        var txt = (node.textContent || '').trim().toLowerCase();
        if (
          txt === 'choose options' ||
          txt === 'choose option'  ||
          txt === 'select options' ||
          txt === 'add to cart'    ||
          node.classList.contains('quick-add__submit')
        ) {
          /* only intercept if this is on a collection page, not product page */
          if (window.location.pathname.indexOf('/products/') === -1) {
            btn = node;
            break;
          }
        }
      }
      node = node.parentElement;
    }

    if (!btn) { return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    var url = getProductUrl(btn);
    if (!url) { return; }

    /* strip query string */
    url = url.split('?')[0];

    var orig = btn.textContent;
    btn.textContent = 'Loading\u2026';
    btn.disabled = true;

    fetch(url + '.json')
      .then(function (r) {
        if (!r.ok) { throw new Error(r.status); }
        return r.json();
      })
      .then(function (data) {
        btn.textContent = orig;
        btn.disabled = false;
        populateSheet(url, data.product);
      })
      .catch(function () {
        btn.textContent = orig;
        btn.disabled = false;
        window.location.href = url;
      });

  }, true); /* capture phase — fires before any other handler */

}());